// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nbody {\n  font-family: Microsoft YaHei;\n}\n@media print {\nbody * {\n    visibility: hidden;\n}\n#printArea,\n  #printArea * {\n    visibility: visible;\n}\n#printArea {\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
